import './App.css';
import { BrowserRouter, Route, Routes, Navigate } from 'react-router';

import Landing from './pages/Landing';
import Home from './pages/Home';
import Login from './pages/Login';
import Patient from './pages/Patient';
import Consultation from './pages/Consultation';
import ProfileForm from './pages/ProfileForm';
import ProfilePending from './pages/ProfilePending';
import PrivacyPolicy from './pages/PrivacyPolicy';
import Terms from './pages/Terms';
import NotFound from './pages/Notfound';

import ProtectedRoute from './ProtectedRoute';
import VerificationRoute from './VarificationRoute';
import PendingRoute from './PendingRoute';
import PublicRoute from './PublicRoute';
import DeleteAccount from './pages/DeleteAccount';

function App() {
  return (
    <div className="App bg-gradient-to-br from-blue-50 to-green-50">
      <BrowserRouter>
        <Routes>

          {/* 🌍 PUBLIC ROUTES */}
          <Route path="/" element={<Landing />} />

          <Route element={<PublicRoute />}>
            <Route path="/login" element={<Login />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/app/deleteaccount" element={<DeleteAccount/>}/>
          </Route>

          {/* 🟡 PROFILE VERIFICATION */}
          <Route element={<VerificationRoute />}>
            <Route path="/profileform" element={<ProfileForm />} />
          </Route>

          <Route element={<PendingRoute />}>
            <Route path="/profilepending" element={<ProfilePending />} />
          </Route>

          {/* 🔒 PROTECTED ROUTES */}
          <Route element={<ProtectedRoute />}>
            <Route path="/dashboard" element={<Home />} />
            <Route path="/patient/:id" element={<Patient />} />
            <Route path="/consultation/:patientId" element={<Consultation />} />
          </Route>

          {/* ❌ 404 */}
          <Route path="*" element={<NotFound />} />

        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
